var render, staticRenderFns
import script from "./ReportAccountStatusImportRemain.vue?vue&type=script&lang=js&"
export * from "./ReportAccountStatusImportRemain.vue?vue&type=script&lang=js&"
import style0 from "./ReportAccountStatusImportRemain.vue?vue&type=style&index=0&id=055f146f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f146f",
  null
  
)

export default component.exports